/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Mobile Nav Toggle

http://getbootstrap.com/javascript/#collapse

*/

import 'bootstrap/js/collapse';


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Custom Navigation Dropdown and Tweaks

*/

function initNavigation() {

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Toggle a class when mobile nav is expanded

    */

    // init
    var $html = $('html');
    var $softpage_menu_toggle = $('.softpage-menu-toggle');
    var nav_expanded_class = 'nav-expanded';
    var mobile_nav_expanded_class = 'mobile-nav-expanded';
    var toggled_attr = 'data-softpage-toggled';
    var toggled_class = 'is-active';

    // default mobile toggle
    $('.navbar-toggle').on('click',function(e){
        // init
        e.preventDefault();
        var $toggle = $(this);
        // already active
        if ($toggle.hasClass(toggled_class)) {
            $toggle.removeClass(toggled_class);
            $html.removeClass(nav_expanded_class);
            $html.removeClass(mobile_nav_expanded_class);
        }
        // about to toggle
        else {
            $toggle.addClass(toggled_class);
            $html.addClass(nav_expanded_class);
            $html.addClass(mobile_nav_expanded_class);
        }
    });

    // softpage menu toggle
    $softpage_menu_toggle.on('click',function(e){
        // init
        e.preventDefault();
        var $toggle = $(this);
        // already active
        if ($toggle.hasClass(toggled_class)) {
            $toggle.removeClass(toggled_class);
            $(window).trigger('closeSoftpage');
        }
        // about to toggle
        else {
            // $toggle.attr(toggled_attr,'');
            $toggle.addClass(toggled_class);
            $html.addClass(nav_expanded_class);
        }
    });
    $(window).on('softpage:closed',function(){
        $softpage_menu_toggle.removeAttr(toggled_attr);
        $softpage_menu_toggle.removeClass(toggled_class);
        $html.removeClass(mobile_nav_expanded_class);
        $html.removeClass(nav_expanded_class);
    });

}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Touch device navigation fixes

*/

function hideExpandedSubnav() {

    // init
    var device_width = $( window ).width();
    var visible_class = 'visible';
    var $overlay = $( '.content-overlay' );
    var min_width_breakpoint = 992; // when is the full menu shown?

    // hide overlay
    $overlay.removeClass(visible_class);

    // only apply on expanded navigation
    if( device_width >= min_width_breakpoint ) {
        $('.subnav').each(function(){
            var $this = $(this);
            if( $this.hasClass(visible_class) ) {
                $this.removeClass(visible_class);
                $this.parents('.nav-dropdown').removeClass('opened');
            }
        });
    }

}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Init

*/

$(function(){

    // on page load
    initNavigation();

    // custom events
    $(window).on('initNavigation', function() {
        initNavigation();
    });

    $(window).on('hideExpandedSubnav', function() {
        hideExpandedSubnav();
    });

    // initialize again when viewport width has changed
    $(window).on('viewportWidthHasChanged', function(){
        hideExpandedSubnav();
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/navigation.js